// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from MenuItem.module.scss  */
.MenuItem-module-Root_2y_ {
  display: grid;
  justify-content: space-between;
  grid-template-columns: 1fr min-content;
  grid-template-rows: 1fr min-content;
  padding: 8px 12px;
  cursor: pointer; }

.MenuItem-module-Icon_1Uu {
  flex-shrink: 0;
  grid-area: 1 / 2 / 3 / 3;
  width: 24px;
  fill: currentColor; }

.MenuItem-module-Main_ku- {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; }

.MenuItem-module-Description_3Nk {
  grid-area: 2 / 1;
  font-size: 0.875rem;
  line-height: 1.25;
  color: #576875; }

.MenuItem-module-Root_2y_[aria-selected='true'],
.MenuItem-module-Root_2y_:hover {
  border-radius: 4px;
  background-color: #ecf1ff; }

.MenuItem-module-Root_2y_[aria-checked='true'] {
  color: #8168f0; }
  .MenuItem-module-Root_2y_[aria-checked='true'] .MenuItem-module-Main_ku- {
    font-weight: bold; }

.MenuItem-module-Root_2y_[aria-disabled='true'] {
  user-select: none;
  pointer-events: none;
  opacity: 0.5; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Menu/MenuItem/MenuItem.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,aAAa;EACb,8BAA8B;EAC9B,sCAAsC;EACtC,mCAAmC;EACnC,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,cAAc;EACd,wBAAwB;EACxB,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB,EAAE;;AAE3B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc,EAAE;;AAElB;;EAEE,kBAAkB;EAClB,yBAAyB,EAAE;;AAE7B;EACE,cAAc,EAAE;EAChB;IACE,iBAAiB,EAAE;;AAEvB;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY,EAAE","sourcesContent":["/*  imported from MenuItem.module.scss  */\n.MenuItem-module-Root_2y_ {\n  display: grid;\n  justify-content: space-between;\n  grid-template-columns: 1fr min-content;\n  grid-template-rows: 1fr min-content;\n  padding: 8px 12px;\n  cursor: pointer; }\n\n.MenuItem-module-Icon_1Uu {\n  flex-shrink: 0;\n  grid-area: 1 / 2 / 3 / 3;\n  width: 24px;\n  fill: currentColor; }\n\n.MenuItem-module-Main_ku- {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.MenuItem-module-Description_3Nk {\n  grid-area: 2 / 1;\n  font-size: 0.875rem;\n  line-height: 1.25;\n  color: #576875; }\n\n.MenuItem-module-Root_2y_[aria-selected='true'],\n.MenuItem-module-Root_2y_:hover {\n  border-radius: 4px;\n  background-color: #ecf1ff; }\n\n.MenuItem-module-Root_2y_[aria-checked='true'] {\n  color: #8168f0; }\n  .MenuItem-module-Root_2y_[aria-checked='true'] .MenuItem-module-Main_ku- {\n    font-weight: bold; }\n\n.MenuItem-module-Root_2y_[aria-disabled='true'] {\n  user-select: none;\n  pointer-events: none;\n  opacity: 0.5; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
